import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "clear"];
  static values = { scope: { type: String, default: "app" } };

  connect() {
    this.debounceTimer = null;
    this.previousUrl = null;
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    this.toggleClearButton();

    this.debounceTimer = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  clear() {
    this.inputTarget.value = "";
    this.toggleClearButton();
    this.restorePreviousPage();
    this.inputTarget.focus();
  }

  performSearch() {
    const query = this.inputTarget.value.trim();
    const frame = document.getElementById("docs-main");
    if (!frame) return;

    if (query.length < 2) {
      this.restorePreviousPage();
      return;
    }

    if (!this.previousUrl) {
      this.previousUrl = frame.src || window.location.href;
    }

    frame.src = `/search?q=${encodeURIComponent(query)}&scope=${this.scopeValue}`;
  }

  restorePreviousPage() {
    if (this.previousUrl) {
      const frame = document.getElementById("docs-main");
      if (frame) frame.src = this.previousUrl;
      this.previousUrl = null;
    }
  }

  toggleClearButton() {
    if (this.hasClearTarget) {
      this.clearTarget.hidden = this.inputTarget.value.length === 0;
    }
  }
}
